/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import { isUserLoggedIn } from 'state/current-user/selectors';
import JwtLoginComponent from './jwt-login/main';
import config from 'config';

const OAUTH2_AUTHORIZE_URL =
    config('oauth2ServerUrl') + '/oauth2/authorize' +
    '?return_url=' + config('clientUrl') + '/jwt-login';

export const login = (context, next) => {
    const userLoggedIn = isUserLoggedIn(context.store.getState());

    if (userLoggedIn) {
        window.location = '/dashboard';
        return;
    }

    window.location = OAUTH2_AUTHORIZE_URL;
};

export const jwtLogin = (context, next) => {
    const userLoggedIn = isUserLoggedIn(context.store.getState());

    if (userLoggedIn) {
        window.location = '/dashboard';
        return;
    }

    // eccserver returns ?token=...
    context.primary = <JwtLoginComponent jwt={context.query.token} />;
    next();
};
